import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { addBusOperaotrStaffApi, adminChangePartnerApprovalStatus, adminGetDriverDetailsById, busOperatorRateApi, cityByCountryApi, countryListApi, getBusOperatorDetailsApi, getBusOperatorDriversApi, getBusOperatorVehiclesApi, savePartnerBankDetailsApi, updateBusOperaotrStaffApi, updateBusOperaotrVehiclesApi, updateBusOperatorCommissionApi, updateBusOperatorDetailsApi, updatePartnerProfileApi, uploadFileApi } from '../../../utils/ApiEndpointFunctions';
import Spinwheel from '../../common/Spinwheel';
import { capitalizeWords, } from '../../../utils/HelperFuncitons';
import { S3_URL } from '../../../utils/BaseUrl';
import ConfirmationModal from '../../common/ConfirmationModal';
import ImageViewModal from '../../common/Modal/ImageViewModal';
import toast from 'react-hot-toast';
import CommonTable from '../../common/Table/CommonTable';
import AddOrUpdateDetails from '../../common/Modal/AddOrUpdateDetails';
import { useFormik } from 'formik';
import { bankDetailsInitialValue, bankDetailsValidationSchema, busOpCommissionInitialValues, busOpCommissionlidationSchema, busOperatorDriverInitialValues, busOperatorDriverValidationSchema, busOperatorInitalValues, busOperatorValidationSchema, busOperatorVehicleInitialValues, busOperatorVehicleValidationSchema, driverRateIntialValue, driverRateValidationSchema, profileDetailsInitialValue, profileValidationSchema, rateRestaurantInitialValues, rateRestaurantValidationSchema, vehicleInitialValue, vehicleValidationSchema } from '../../common/Validation';
import { useAdminContext } from '../../../context/adminContext';
import PdfSvgIcon from '../../common/PdfSvgIcon';


const BusOperatorDetails = (props) => {
  const params = useParams();
  const [id, setId] = useState(params?.id)
  const [partnerDetails, setPartnerDetails] = useState({});
  const [bankDetails, setBankDetails] = useState([]);
  const [loader, setLoader] = useState(true);
  const [activeTab, setActiveTab] = useState('profile');
  const [confirmStatus, setConfirmStatus] = useState({ status: "", userId: "", role: "busOperator" });
  const [selectedImg, setSelectedImg] = useState("")
  const [busOperatorDetails, setBusOperatorDetails] = useState({});
  const confirmationModalId2 = "confirmationModal2"
  const busOperatorBankModal2 = "busOperatorBankModal2"
  const [selectDocDate,] = useState("")
  const [detailsType, setDetailsType] = useState({ type: "", loading: false })
  const [fileUpload, setFileUpload] = useState([])
  const [driverDetails, setDriverDetails] = useState([])
  const [vehiclesDetails, setVehicleDetails] = useState([])
  const [countryOptions, setCountryOptions] = useState([])
  const [cityOptions, setCityOptions] = useState([])
  const [submitLoader, setSubmitLoader] = useState(false);
  const { adminDetail, setAdminDetail } = useAdminContext()

  const filterCites = async (countryId) => {
    try {
      const res = await cityByCountryApi("", countryId);
      if (res.status === 200) {
        let cityOption = res.data?.data?.map(ele => ({
          label: ele.name,
          value: ele.id
        }));
        setCityOptions(cityOption);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const filterCountry = async (inputValue) => {
    try {
      const res = await countryListApi(inputValue);
      if (res.status === 200) {
        let countryOption = res.data?.data?.map(ele => ({
          label: ele.name,
          value: ele.id   // 👈 yaha id assign karo
        }));
        setCountryOptions(countryOption);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    filterCites("")
    filterCountry("")
  }, [])




  // const handleCityChange = (city) => {
  //   searchFormik.setFieldValue('cityId', city)
  // }

  // const handleCountryChange = (country) => {
  //   console.log(country, 'this is count')
  //   setCityOptions([])
  //   searchFormik.setFieldValue('countryId', country);
  //   searchFormik.setFieldValue('cityId', null);
  //   filterCites(country.value)
  // }

  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Other", value: "other" },
  ]

  const detailsFields = {
    "bankDetails": {
      format: [
        { name: "bankName", label: "Bank Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "accountNo", label: "Account No", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
        { name: "accountType", label: "Account Type", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "Ifsc", label: "IFSC", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
      ],
      initialvalue: bankDetailsInitialValue,
      validationSchema: bankDetailsValidationSchema,
      handleSubmit: (values) => handlePartnerDetailSubmit(values, savePartnerBankDetailsApi),
      modalId: busOperatorBankModal2
    },
    "profile": {
      format: [
        { name: "profileImage", label: "Profile image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("profileImage"), handleFileUpload },
        { name: "name", label: "Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "alternateMobile", label: "Alternate mobile", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
        { name: "email", label: "Email", type: "input", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "NIN", label: "NIN", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "zip", label: "Zip", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        {
          name: "country",
          label: "Country",
          type: "select",
          options: countryOptions,
          handleOnChange: (name, selectedOption, formik, type) => {
            console.log("Country selectedOption: ", selectedOption);
            formik.setFieldValue(name, selectedOption); 
            if (selectedOption?.value) {
              filterCites(selectedOption.value); 
            }
          }
        },

        {
          name: "city",
          label: "City",
          type: "select",
          options: cityOptions,
          handleOnChange: (name, selectedOption, formik, type) => {
            console.log("City selectedOption: ", selectedOption);
            formik.setFieldValue(name, selectedOption);
          }
        },
        { name: "state", label: "State", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "permanentAddress", label: "Permanent address", type: "address", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "gender", label: "Gender", type: "select", options: genderOptions, handleOnChange: (...values) => handleInputChange(...values, "text") },
      ],
      initialvalue: profileDetailsInitialValue,
      validationSchema: profileValidationSchema,
      handleSubmit: (values) => handlePartnerDetailSubmit({ ...values, gender: values?.gender?.value, country:values?.country?.label, city:values?.city?.label }, updatePartnerProfileApi),
      // handleSubmit: (values) => console.log("my check",values,values?.country?.label),
      modalId: busOperatorBankModal2
    },
    "driver": {
      format: [
        { name: "profileImg", label: "Profile image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("profileImage"), handleFileUpload },
        { name: "firstName", label: "First Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "lastName", label: "Last Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "phone", label: "Phone", type: "phone", handleOnChange: (...values) => handleInputChange(...values, "phone") },
        // { name: "email", label: "Email", type: "input", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        // { name: "NIN", label: "NIN", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        // { name: "permanentAddress", label: "Permanent address", type: "address", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "gender", label: "gender", type: "select", options: genderOptions, handleOnChange: (...values) => handleInputChange(...values, "text") },
      ],
      initialvalue: busOperatorDriverInitialValues,
      validationSchema: busOperatorDriverValidationSchema,
      // handleSubmit: (values) => handlePartnerDetailSubmit({ ...values, gender: values?.gender?.value }, updateBusOperaotrStaffApi),
      // modalId: busOperatorBankModal2
      handleSubmit: (values) => {
        let payload = { ...values, gender: values?.gender?.value };
        if (values.id) {
          handlePartnerDetailSubmit(payload, updateBusOperaotrStaffApi);
        } else {
          payload = { ...payload, partnerUserId: id, type: "driver" }
          handlePartnerDetailSubmit(payload, addBusOperaotrStaffApi);
        }
      },

      modalId: busOperatorBankModal2
    },
    "hostess": {
      format: [
        { name: "profileImg", label: "Profile image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("profileImage"), handleFileUpload },
        { name: "firstName", label: "First Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "lastName", label: "Last Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "phone", label: "Phone", type: "phone", handleOnChange: (...values) => handleInputChange(...values, "phone") },
        // { name: "email", label: "Email", type: "input", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        // { name: "NIN", label: "NIN", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        // { name: "permanentAddress", label: "Permanent address", type: "address", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "gender", label: "gender", type: "select", options: genderOptions, handleOnChange: (...values) => handleInputChange(...values, "text") },
      ],
      initialvalue: busOperatorDriverInitialValues,
      validationSchema: busOperatorDriverValidationSchema,
      // handleSubmit: (values) => handlePartnerDetailSubmit({ ...values, gender: values?.gender?.value }, updateBusOperaotrStaffApi),
      // modalId: busOperatorBankModal2

      handleSubmit: (values) => {
        let payload = { ...values, gender: values?.gender?.value };
        if (values.id) {
          handlePartnerDetailSubmit(payload, updateBusOperaotrStaffApi);
        } else {
          payload = { ...payload, partnerUserId: id, type: "hostess" }
          handlePartnerDetailSubmit(payload, console.log(payload));
        }
      },

      modalId: busOperatorBankModal2
    },

    "bus-operator": {
      format: [
        { name: "companyName", label: "Company Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "displayName", label: "Display Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        // { name: "TIN", label: "TIN", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "taxIdentification", label: "Tax Identification", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "businessLicence", label: "Business Licence", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "companyLogo", label: "Company Logo", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("logo"), handleFileUpload },
        // { name: "businessLicenceFile", label: "Business Licence File", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("logo"), handleFileUpload },
        { name: "businessLicenceFile", label: "Business Licence File", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("logo"), handleFileUpload },
        { name: "taxIdentificationFile", label: "Tax Identification File", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("logo"), handleFileUpload },
      ],
      initialvalue: busOperatorInitalValues,
      validationSchema: busOperatorValidationSchema,
      handleSubmit: (values) => handlePartnerDetailSubmit(values, updateBusOperatorDetailsApi),
      modalId: busOperatorBankModal2
    },
    "Vehicle": {
      format: [
        { name: "busType", label: "Bus Type", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "registrationNo", label: "Registration No", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "name", label: "Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "rcDocument", label: "Rc Document", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("profileImage"), handleFileUpload },
        { name: "insuranceDocument", label: "Insurance Document", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("profileImage"), handleFileUpload },
      ],
      initialvalue: busOperatorVehicleInitialValues,
      validationSchema: busOperatorVehicleValidationSchema,

      handleSubmit: (values) => {
        let payload = { ...values };
        if (values.id) {
          handlePartnerDetailSubmit(payload, updateBusOperaotrVehiclesApi);
        } else {
          payload = { ...payload, partnerUserId: id }
          // handlePartnerDetailSubmit(payload, console.log(payload));
        }
      },

      modalId: busOperatorBankModal2
    },

  }

  const partnerDetailsFormik = useFormik({
    initialValues: detailsFields?.[activeTab]?.initialvalue,
    validationSchema: detailsFields?.[activeTab]?.validationSchema,
    enableReinitialize: true,
    onSubmit: detailsFields?.[activeTab]?.handleSubmit
  })

  useEffect(() => {
    console.log("errors", partnerDetailsFormik.errors)
  }, [partnerDetailsFormik.errors])

  async function handlePartnerDetailSubmit(payload, apiEndPoint) {
    try {
      setDetailsType({ ...detailsType, loading: true })
      const res = await apiEndPoint({ ...payload, partnerUserId: id })
      if (res?.status == 200 || res?.status == 201) {
        fetchPartnerDetails();
        fetchDrivers();
        fetchVehicle();
        document.getElementById(detailsFields[activeTab]?.modalId)?.click()
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something Went Wrong")
    }
    setDetailsType({ ...detailsType, loading: false })
  }


  async function handleFileUpload(name, e, formik) {
    try {
      const file = e.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("type", "documents")
        setFileUpload([...fileUpload, name])
        const res = await uploadFileApi(formData)
        formik.setFieldTouched(name, true)
        if (res.status === 200 && res.data?.status === 1) {
          formik.setFieldValue(name, res.data?.data);
          toast.success("File uploaded");
        }
      }
    } catch (error) {
      formik.setFieldTouched(`image`, true)
      console.log(error)
      if (error?.response === undefined) {
        toast.error("File size is too large")
      }
    }
    setFileUpload([...fileUpload?.filter(ele => ele != name)])
  }

  const fetchPartnerDetails = async () => {
    try {
      const res = await getBusOperatorDetailsApi(id);
      if (res.status === 200) {
        const { id, role, phone, referralCode, partnerUserDetails, bankDetails, busOperator } = res.data.data;
        console.log(res.data)
        setPartnerDetails({ id, phone, referralCode, role, ...partnerUserDetails[0], status:busOperator?.status });
        setBankDetails(bankDetails);
        setBusOperatorDetails(busOperator);
        rateFormik.setValues({ id: id, commission: busOperator?.commission, discountOnOff: busOperator?.discountOnOff, discount: busOperator?.discount });
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  useEffect(() => { console.log("bus op details", busOperatorDetails) }, [busOperatorDetails])

  const fetchDrivers = async () => {
    try {
      setLoader(true)
      const res = await getBusOperatorDriversApi(id, activeTab);
      if (res.status === 200) {
        console.log("res", res?.data?.data)
        setDriverDetails(res?.data?.data)
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  }

  const fetchVehicle = async () => {
    try {
      setLoader(true)
      const res = await getBusOperatorVehiclesApi(id);
      if (res.status === 200) {
        console.log("res", res?.data?.data)
        setVehicleDetails(res?.data?.data)
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  }

  useEffect(() => {
    fetchVehicle()
    fetchDrivers()
  }, [id])

  const handleChangeStatus = async () => {
    try {
      setLoader(true)
      await adminChangePartnerApprovalStatus(confirmStatus)
      fetchPartnerDetails();
      document.getElementById('confirmationModal').click()
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something Went Wrong")
      setLoader(false)
    }
  }


  useEffect(() => {
    if (id) {
      fetchPartnerDetails();
    }
  }, [id]);

  const toggleTab = (tab) => {
    setActiveTab(tab);
  };


  const bankDetailsHeaderData = [
    { name: "Account Holder Namer", className: "list-sort text-muted", key: "name" },
    { name: "Bank Name", className: "list-sort text-muted", key: "bankName" },
    { name: "IFSC", className: "list-sort text-muted", key: "Ifsc" },
    { name: "Account Number", className: "list-sort text-muted", key: "accountNo" },
    { name: "Account Type", className: "list-sort text-muted", key: "accountType" },
    { name: <div className='d-flex gap-2 justify-content-center align-items-center'><div>Action</div><div>{!bankDetails?.length && <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target={`#busOperatorBankModal2`}>Add</button>}</div></div>, className: "col-1", key: "action" },

  ]

  const bankDetailsTableData = bankDetails.map((bnk, index) => ({
    name: partnerDetails?.name || "",
    bankName: bnk.bankName || "",
    Ifsc: bnk.Ifsc || "",
    accountNo: bnk.accountNo || "",
    accountType: bnk.accountType || "",
    action: (
      <div className="dropdown">
        <button
          className=" border-0 bg-white"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-three-dots-vertical"
            viewBox="0 0 16 16">
            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
          </svg>
        </button>
        <ul
          className="dropdown-menu"
          style={{ zIndex: "1000" }}>
          <li data-bs-toggle="modal" data-bs-target={`#${detailsFields?.[activeTab]?.modalId}`} onClick={() => { partnerDetailsFormik?.setValues(bnk) }}>
            <a className="dropdown-item" href="#">
              Edit
            </a>
          </li>
        </ul>
      </div>
    )
  }))

  const driversHeaderData = [
    { name: "S.N", className: "list-sort text-muted", key: "sNo" },
    { name: "Profile Image", className: "list-sort text-muted", key: "profileImg" },
    { name: "First Name", className: "list-sort text-muted", key: "firstName" },
    { name: "Last Name", className: "list-sort text-muted", key: "lastName" },
    { name: "Gender", className: "list-sort text-muted", key: "gender" },
    { name: "Phone", className: "list-sort text-muted", key: "phone" },
    // { name: <div className='d-flex gap-2 justify-content-center align-items-center'><div>Action</div><div>{!bankDetails?.length && <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target={`#busOperatorBankModal2`}>Add</button>}</div></div>, className: "col-1", key: "action" },
    { name: "Action", className: "list-sort text-muted", key: "action" },
    {
      name: (
        <button
          className="btn btn-primary btn-sm"
          data-bs-toggle="modal"
          data-bs-target="#busOperatorBankModal2"
          onClick={() => {
            partnerDetailsFormik.resetForm({
              values: detailsFields["driver"].initialvalue
            });
          }}
        >
          Add
        </button>
      ),
      className: "list-sort text-muted",
      key: "add"
    }
  ]

  const driversTableData = driverDetails
    ?.filter(driver => driver?.type === "driver")
    ?.map((driver, index) => ({
      sNo: index + 1,
      profileImg: driver?.profileImg && (
        <img
          src={`${S3_URL}/${driver.profileImg}`}
          alt="Profile"
          style={{
            width: "50px",
            height: "50px",
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
      ),
      firstName: driver?.firstName || "",
      lastName: driver?.lastName || "",
      gender: driver?.gender || "",
      phone: driver?.phone || "",
      action: (
        <div className="dropdown">
          <button
            className=" border-0 bg-white"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-three-dots-vertical"
              viewBox="0 0 16 16">
              <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
            </svg>
          </button>
          <ul
            className="dropdown-menu"
            style={{ zIndex: "1000" }}>
            <li data-bs-toggle="modal" data-bs-target={`#${detailsFields?.[activeTab]?.modalId}`} onClick={() => { partnerDetailsFormik?.setValues(driver) }}>
              <a className="dropdown-item" href="#">
                Edit
              </a>
            </li>
          </ul>
        </div>
      )
    }))

  const hostessHeaderData = [
    { name: "S.N", className: "list-sort text-muted", key: "sNo" },
    { name: "Profile Image", className: "list-sort text-muted", key: "profileImg" },
    { name: "First Name", className: "list-sort text-muted", key: "firstName" },
    { name: "Last Name", className: "list-sort text-muted", key: "lastName" },
    { name: "Gender", className: "list-sort text-muted", key: "gender" },
    { name: "Phone", className: "list-sort text-muted", key: "phone" },
    // { name: <div className='d-flex gap-2 justify-content-center align-items-center'><div>Action</div><div> <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target={`#busOperatorBankModal2`}>Add</button></div></div>, className: "col-1", key: "action" },
    { name: "Action", className: "list-sort text-muted", key: "action" },
    {
      name: (
        <button
          className="btn btn-primary btn-sm"
          data-bs-toggle="modal"
          data-bs-target="#busOperatorBankModal2"
          onClick={() => {
            partnerDetailsFormik.resetForm({
              values: detailsFields["hostess"].initialvalue
            });
          }}
        >
          Add
        </button>
      ),
      className: "list-sort text-muted",
      key: "add"
    }
  ]

  const hostessTableData = driverDetails
    ?.filter(driver => driver?.type === "hostess")
    ?.map((driver, index) => ({
      sNo: index + 1,
      profileImg: driver?.profileImg && (
        <img
          src={`${S3_URL}/${driver.profileImg}`}
          alt="Profile"
          style={{
            width: "50px",
            height: "50px",
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
      ),
      firstName: driver?.firstName || "",
      lastName: driver?.lastName || "",
      gender: driver?.gender || "",
      phone: driver?.phone || "",
      action: (
        <div className="dropdown">
          <button
            className=" border-0 bg-white"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-three-dots-vertical"
              viewBox="0 0 16 16">
              <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
            </svg>
          </button>
          <ul
            className="dropdown-menu"
            style={{ zIndex: "1000" }}>
            <li data-bs-toggle="modal" data-bs-target={`#${detailsFields?.[activeTab]?.modalId}`} onClick={() => { partnerDetailsFormik?.setValues(driver) }}>
              <a className="dropdown-item" href="#">
                Edit
              </a>
            </li>
          </ul>
        </div>
      )
    }))

  const vehicleHeaderData = [
    { name: "S.N", className: "list-sort text-muted", key: "sNo" },
    { name: "Name", className: "list-sort text-muted", key: "name" },
    { name: "Registration No", className: "list-sort text-muted", key: "registrationNo" },
    { name: "Bus Type", className: "list-sort text-muted", key: "busType" },
    { name: "Seat Layout", className: "list-sort text-muted", key: "seatLayout" },
    { name: "Seat Capacity", className: "list-sort text-muted", key: "seatCapacity" },
    { name: "Rc Document", className: "list-sort text-muted", key: "rcDocument" },
    { name: "Insurance Document", className: "list-sort text-muted", key: "insuranceDocument" },
    { name: "Action", className: "list-sort text-muted", key: "action" },
    // {
    //   name: (
    //     <button
    //       className="btn btn-primary btn-sm"
    //       data-bs-toggle="modal"
    //       data-bs-target="#busOperatorBankModal2"
    //       onClick={() => {
    //         partnerDetailsFormik.resetForm({
    //           values: detailsFields["vehicle"].initialvalue
    //         });
    //       }}
    //     >
    //       Add
    //     </button>
    //   ),
    //   className: "list-sort text-muted",
    //   key: "add"
    // }
  ]

  const VehcileTableData = vehiclesDetails
    ?.map((vehicle, index) => ({
      sNo: index + 1,
      registrationNo: vehicle?.registrationNo || "",
      name: vehicle?.name || "",
      busType: vehicle?.busType || "",
      seatLayout: vehicle?.seatLayout || "",
      seatCapacity: vehicle?.seatCapacity || "",
      rcDocument: vehicle?.rcDocument && (
        <img
          src={`${S3_URL}/${vehicle.rcDocument}`}
          alt="Profile"
          style={{
            width: "50px",
            height: "50px",
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
      ),
      insuranceDocument: vehicle?.insuranceDocument && (
        <img
          src={`${S3_URL}/${vehicle.insuranceDocument}`}
          alt="Profile"
          style={{
            width: "50px",
            height: "50px",
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
      ),
      action: (
        <div className="dropdown">
          <button
            className=" border-0 bg-white"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-three-dots-vertical"
              viewBox="0 0 16 16">
              <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
            </svg>
          </button>
          <ul
            className="dropdown-menu"
            style={{ zIndex: "1000" }}>
            <li data-bs-toggle="modal" data-bs-target={`#${detailsFields?.[activeTab]?.modalId}`} onClick={() => { partnerDetailsFormik?.setValues(vehicle) }}>
              <a className="dropdown-item" href="#">
                Edit
              </a>
            </li>
          </ul>
        </div>
      )
    }))

  useEffect(() => {
    console.log("partner details", partnerDetails)
  }, [partnerDetails])

  const profileData = [
    { name: "Email", data: partnerDetails.email, },
    { name: "Phone", data: partnerDetails.phone, },
    { name: "Alternate Phone", data: partnerDetails.alternateMobile, },
    // { name: "Emergency Contact", data: partnerDetails.emergencyContact, },
    { name: "NIN", data: partnerDetails.NIN, },
    { name: "Status", data: capitalizeWords(partnerDetails.status), },
    { name: "Role", data: partnerDetails?.role?.map(el => capitalizeWords(el))?.join(", "), },
    { name: "Gender", data: partnerDetails.gender, },
    { name: "City", data: partnerDetails.city, },
    { name: "State", data: partnerDetails.state, },
    { name: "Country", data: partnerDetails.country, },
    { name: "Zip Code", data: partnerDetails.zip, },
    { name: "Driving Experience", data: (partnerDetails.drivingExp || 0) + " years", },
    { name: "Address", data: <div>{partnerDetails.permanentAddress && `${partnerDetails.permanentAddress}, `}{partnerDetails.state && `${partnerDetails.state}, `}{partnerDetails.city && `${partnerDetails.city}, `}{partnerDetails.zip && `${partnerDetails.zip}`}</div>, },
    { name: "Referral Code", data: partnerDetails.referralCode, },
  ]

  const busOperator = [
    { name: "Company name", data: busOperatorDetails?.companyName, },
    { name: "Display name", data: busOperatorDetails?.displayName, },
    { name: "Business Licence", data: busOperatorDetails?.businessLicence },
    {
      name: "Business Licence File",
      data: busOperatorDetails?.businessLicenceFile
        ? `${S3_URL}/${busOperatorDetails.businessLicenceFile}`
        : ""
    },
    {
      name: "Tax Identification",
      data: busOperatorDetails?.taxIdentification
    },
    {
      name: "Tax Identification File",
      data: busOperatorDetails?.taxIdentificationFile
        ? `${S3_URL}/${busOperatorDetails.taxIdentificationFile}`
        : ""
    },
    {
      name: "Company Logo",
      data: busOperatorDetails?.companyLogo?.split(".")?.slice(- 1)?.includes("pdf") ?
        <Link to={`${S3_URL}/${busOperatorDetails?.companyLogo}`}  > <PdfSvgIcon width="100" height="100" /></Link>
        :
        <img
          src={busOperatorDetails?.companyLogo ? `${S3_URL}/${busOperatorDetails?.companyLogo}` : "https://www.team-bhp.com/sites/default/files/pictures2021/2.jpg"}
          alt={"img"}
          data-bs-toggle="modal"
          data-bs-target={`#imageViewModal`}
          style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '100px', borderRadius: "8%" }}
          onClick={() => { setSelectedImg(busOperatorDetails?.companyLogo ? `${S3_URL}/${busOperatorDetails?.companyLogo}` : "https://www.team-bhp.com/sites/default/files/pictures2021/2.jpg") }}
        />,
    },
  ]

  function handleInputChange(name, e, formik, input, type) {
    if (input == "input") {
      const { value } = e?.target
      if (type == "number" && isNaN(value)) return
      formik.setFieldValue(name, value)
    } else if (input == "date") {
      formik.setFieldValue(name, e)
    } else if (input == "select") {
      let list = [{ name, value: e }]
      if (name == "categoryId") {
        list.push({ name: "modelId", value: "" }, { name: "makeId", value: "" })
      } else if (name == "modelId") {
        list.push({ name: "makeId", value: "" })
      }

      list?.forEach(ele => {
        formik.setFieldValue(ele?.name, ele?.value)
      })
    } else if (input == "address") {
      formik.setFieldValue(name, e?.label)
    } else if (input == "phone") {
      formik.setFieldValue(name, e)
    }

  }

  const rateFormik = useFormik({
    initialValues: busOpCommissionInitialValues,
    validationSchema: busOpCommissionlidationSchema,
    onSubmit: async (values) => {
      try {
        setSubmitLoader(true)
        const res = await updateBusOperatorCommissionApi(values)
        if (res.status === 200) {
          console.log(res.data?.data)
          toast.success(res.data.message);
        }
      } catch (error) {
        console.error(error)
      }

      setSubmitLoader(false)
    }
  })


  const tabData = [
    {
      name: "Profile Details",
      tab: "profile",
      setTab: toggleTab,
      data: (
        <div className="row card">
          <div className="row mt-3">
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-primary"
                onClick={() =>
                  partnerDetailsFormik.setValues({
                    ...partnerDetails,
                    gender: {
                      label: capitalizeWords(partnerDetails?.gender),
                      value: partnerDetails?.gender,
                    },
                    country:{
                      label: capitalizeWords(partnerDetails?.country),
                      value: partnerDetails?.country,
                    },
                    city:{
                      label: capitalizeWords(partnerDetails?.city),
                      value: partnerDetails?.city,
                    }
                  })
                }
                data-bs-toggle="modal"
                data-bs-target={`#busOperatorBankModal2`}
              >
                Edit
              </button>
            </div>
            <div className="user-details">
              <table className="table table-md table-hover card-table">
                <tbody>
                  {profileData.map((ele, index) => (
                    <tr key={index}>
                      <td>{ele.name}:</td>
                      <td>{ele.data}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ),
    },
    {
      name: "Bus Operator",
      tab: "bus-operator",
      setTab: toggleTab,
      data: (
        <div className="row card">
          <div className="row mt-3">
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-primary"
                onClick={() =>
                  partnerDetailsFormik.setValues({
                    ...busOperatorDetails,
                  })
                }
                data-bs-toggle="modal"
                data-bs-target={`#busOperatorBankModal2`}
              >
                Edit
              </button>
            </div>
            <div className="user-details">
              <table className="table table-md table-hover card-table">
                <tbody>
                  {busOperator.map((ele, index) => (
                    <tr key={index}>
                      <td>{ele.name}:</td>
                      <td>
                        {(ele.name === "Business Licence File" || ele.name === "Tax Identification File") ? (
                          <img
                            src={ele.data}
                            alt={ele.name}
                            style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '100px', borderRadius: "8%" }}
                            data-bs-toggle="modal"
                            data-bs-target="#imageViewModal"
                            onClick={() => setSelectedImg(ele.data)}
                          />
                        ) : (
                          ele.data
                        )}
                      </td>
                    </tr>
                  ))}



                </tbody>
              </table>
            </div>
          </div>
        </div>
      ),
    },
    {
      name: "Bank Details",
      tab: "bankDetails",
      setTab: toggleTab,
      data: (
        <div className="card row">
          <CommonTable
            headers={bankDetailsHeaderData}
            data={bankDetailsTableData}
          />
        </div>
      ),
    },
    adminDetail?.role === "superAdmin" && {
      name: "Rate", tab: "rate", setTab: toggleTab, data:
        <div className="card">
          <div className="card-header" style={{ backgroundColor: "var(--color-card-bg)" }}>
            Rate
          </div>
          <div className="card-body" >
            <div className='p-5'>
              <form onSubmit={rateFormik.handleSubmit}>
                <div className="form-group row row-cols-4">
                  <div className='d-flex gap-3'>
                    <label htmlFor='commission' className=" col-form-label">Commission(%)</label>
                    <div className="">
                      <input type="text" className="form-control" id='commission' placeholder="0" name='commission' onChange={rateFormik.handleChange} onBlur={rateFormik.handleBlur} value={rateFormik.values.commission} />
                      {rateFormik.touched?.commission && rateFormik.errors?.commission ? (<div className='req-error'>{rateFormik?.errors?.commission}</div>) : null}
                    </div>
                  </div>

                  <div className='d-flex gap-3'>
                    <label htmlFor='discount' className=" col-form-label">Discount(%)</label>
                    <div className="">
                      <input type="text" className="form-control" id='discount' placeholder="0" name='discount' onChange={rateFormik.handleChange} onBlur={rateFormik.handleBlur} value={rateFormik.values.discount} />
                      {rateFormik.touched?.discount && rateFormik.errors?.discount ? (<div className='req-error'>{rateFormik?.errors?.discount}</div>) : null}
                    </div>
                  </div>

                  <div className='d-flex align-items-center gap-3'>
                    <label htmlFor='descountOnOff' className=" col-form-label">Discount(on/off)</label>
                    <div className="form-check form-switch">
                      <input className="form-check-input" type="checkbox" role="switch" checked={rateFormik?.values?.discountOnOff} id="discountOnOff" onChange={() => rateFormik?.setFieldValue("discountOnOff", !Boolean(rateFormik?.values?.discountOnOff))} />
                      {rateFormik.touched?.discountOnOff && rateFormik.errors?.discountOnOff ? (<div className='req-error'>{rateFormik?.errors?.discountOnOff}</div>) : null}
                    </div>
                  </div>
                  <div className="d-flex align-items-end"  >
                    <button type="submit" className="btn btn-sm btn-primary" disabled={submitLoader}>Submit</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
    },
    {
      name: "Driver",
      tab: "driver",
      setTab: toggleTab,
      data: (
        <div className="card row">
          <CommonTable
            headers={driversHeaderData}
            data={driversTableData}
          />
        </div>
      ),
    },
    {
      name: "Hostess",
      tab: "hostess",
      setTab: toggleTab,
      data: (
        <div className="card row">
          <CommonTable
            headers={hostessHeaderData}
            data={hostessTableData}
          />
        </div>
      ),
    },
    {
      name: "Vehicles",
      tab: "Vehicle",
      setTab: toggleTab,
      data: (
        <div className="card row">
          <CommonTable
            headers={vehicleHeaderData}
            data={VehcileTableData}
          />
        </div>
      ),
    },

  ];

  return (
    <div className="main-content">
      <div className="container-fluid">
        {loader ? (
          <div className="text-center">
            <Spinwheel />
          </div>
        ) : (
          <>
            <div className="row align-items-end">
              <div className="col-auto">
                <div className="avatar avatar-xxl header-avatar-top mt-3">
                  <img src={partnerDetails?.profileImage ? `${S3_URL}/${partnerDetails?.profileImage}` : "https://img.freepik.com/premium-vector/man-avatar-profile-picture-vector-illustration_268834-538.jpg"} alt="profile" className="avatar-img rounded-circle border border-4 border-body" />
                </div>
              </div>
              <div className="col mb-3 ms-n3 ms-md-n2">
                <h1 className="header-title">
                  {capitalizeWords(partnerDetails?.name)}
                </h1>
              </div>
              <div className="col-12 col-md-auto mt-2 mt-md-0 mb-md-3">
                {(busOperatorDetails?.status === "pending") ? <><button type="button" className="btn btn-outline-primary me-2" data-bs-toggle="modal"
                  data-bs-target={`#confirmationModal`}
                  onClick={(e) => { setConfirmStatus(prevState => ({ ...prevState, status: "approved", userId: id })) }}>Approve</button>
                  <button type="button" className="btn btn-outline-secondary" data-bs-toggle="modal"
                    data-bs-target={`#confirmationModal`}
                    onClick={(e) => { setConfirmStatus(prevState => ({ ...prevState, status: "rejected", userId: id })) }}>Reject</button></> :
                  <div className={`badge fs-4  ${partnerDetails?.driverStatus === "approved" ? "bg-primary-soft" : "bg-secondary-soft"}`}>{capitalizeWords(busOperatorDetails?.status)}</div>
                }
              </div>
            </div>

            <div className='d-flex justify-content-between'>
              <ul className="nav nav-tabs">
                {
                  tabData.map((ele, index) => (
                    <li className="nav-item">
                      <button
                        className={`nav-link ${activeTab === ele.tab ? 'active' : ''}`}
                        onClick={() => ele.setTab(ele.tab)}
                      >
                        {ele.name}
                      </button>
                    </li>
                  ))
                }
              </ul>
              <div>
              </div>
            </div>

            {
              tabData.map((ele, index) => (
                activeTab === ele.tab ? ele.data : null
              ))
            }
          </>
        )}

        {<ConfirmationModal
          handleConfirm={handleChangeStatus}
          confirmStatus={confirmStatus}
        />}
        <ImageViewModal imgUrl={selectedImg} modalId={"imageViewModal"} />
        {console.log(selectDocDate)}
        <button id="confirmationModal2Btn" className='d-none' data-bs-toggle="modal" data-bs-target={`#${confirmationModalId2}`}></button>
        <AddOrUpdateDetails formik={partnerDetailsFormik} dataFormat={detailsFields[activeTab]?.format} detailsFor={detailsType?.type} addLoader={detailsType?.loading} modalId={busOperatorBankModal2} />

      </div>
    </div>

  );
};

export default BusOperatorDetails;
